import { ReactElement, useEffect, useRef } from "react";
export { MessageProvider, usePushMessage } from "./message";
import { MessageProvider } from "./message";
import { AuthProvider } from "./authProvider";
import { ModalProvider } from "./modal";
import { CartProvider } from "./cart";
import { useNavigate, useLocation } from "react-router-dom";
import { useLocalStorageState } from "../hooks";

export const Providers = ({ children }: ReactElement["props"]) => {
  const navigate = useNavigate();
  const location = useLocation();
  const redirected = useRef(false);
  const [hasAcceptedDevSite] = useLocalStorageState(
    "accept-dev-site",
    "dev-not-accepted"
  );
  useEffect(() => {
    if (
      import.meta.env.VITE_STAGE !== "prod" &&
      ((typeof hasAcceptedDevSite === "string" &&
        !hasAcceptedDevSite.startsWith("dev-accepted")) ||
        typeof hasAcceptedDevSite === "boolean") &&
      !location.pathname.startsWith("/accept-dev-site") &&
      !redirected.current
    ) {
      redirected.current = true;
      // navigate("/accept-dev-site?current-page=" + location.pathname);
    }
  }, [navigate, hasAcceptedDevSite, location.pathname]);
  return (
    <ModalProvider>
      <MessageProvider>
        <AuthProvider>
          <CartProvider>
            <>{children}</>
          </CartProvider>
        </AuthProvider>
      </MessageProvider>
    </ModalProvider>
  );
};
